import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Select } from '../../components'
import './benchmark.scss'
import Filter from './filter/filter'
import Grafico from './grafico'
import { setProjeto } from '../../layout/redux/layoutActions'

export default () => {
  const dispatch = useDispatch()

  const { sistema } = useSelector(state => state.layoutState)
  const { projeto, projetos } = useSelector(state => state.benchmarkState)

  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsContexto = require(`../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const handleFormFilter = (e) => {
    dispatch(setProjeto(e.value))
  }

  return (
        <div className='box-benchmark' data-cy='page-benchmark'>
      <div className='box-benchmark-topinfo'>
        <div>
          <div className='box-benchmark-topinfo-select'>
            <Select
            name='projeto'
            cy='filter-project'
            label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e) => handleFormFilter(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
        </div>
      </div>

      <Filter />

      <Grafico nlsContexto={nlsContexto} nls={nls} />
    </div>
  )
}